import { ApiService } from "./api.service";

export default class ViewingFileComments extends ApiService {
  namespace = "comments";
  icon = "BlueCube";
  name = "Type";
  favicon = "Comment";
  window = 290;
  Width = 690;
  realm = 2;
  DOMAIN = -45;
  constructor() {
    super("comments");
  }
}
